<div class="annual-plan-graph-dialog">
    <h1 mat-dialog-title>
        {{ 'Week' | translate}} {{ week.realWeekNumber || week.weekNumber }}
        <span *ngIf="week.realWeekNumber">{{ week.firstDayOfWeek.toString()|appDate:'mediumDate' }} - {{ week.lastDayOfWeek.toString()|appDate:'mediumDate' }}</span>
    </h1>
    <div mat-dialog-content>
        <ul id="legend">
            <li class="intensity">{{ 'Intensity'|translate }} <span>{{ week.intensityPercent }} %</span></li>
        </ul>

        <hr />

        <div *ngIf="0 < week.accents.length; else noAccents">
            <ul id="accents">
                <li class="competition" *ngFor="let accent of week.accents">
                    <span class="bullet" [ngStyle]="{'background': accent.color}"></span> {{ accent.name }} ({{ accent.seconds | secondsToDHM:true | default:'-' }})
                </li>
            </ul>
        </div>

        <ng-template #noAccents>
            {{ 'message.no_accent'|translate }}
        </ng-template>
    </div>
    <div mat-dialog-actions
         class="actions">
        <button mat-raised-button [mat-dialog-close]="" color="accent">{{ 'Close'|translate }}</button>
    </div>
</div>
